import UserAlertCriterion from "@/services/UserAlertCriterion";

const validateCriteriaShouldBeUpdated = (storeCriterion, criterion) => {
    const daysChanged = storeCriterion.days_without_access !== criterion.criterionData.days_without_access;
    const progressChanged = storeCriterion.overall_progress !== criterion.criterionData.overall_progress;

    return daysChanged || progressChanged;
}

export default {
    state() {
        return {
            userAlertCriteria: [],
        }
    },

    getters: {
        getUserAlertCriteria: (state) => state.userAlertCriteria,
        getRegularCriterion: (state) => {
            return state.userAlertCriteria.find(c => c.alert_criterion?.name === 'Regular') || null;
        },
        getAlertCriterion: (state) => {
            return state.userAlertCriteria.find(c => c.alert_criterion?.name === 'Alerta') || null;
        },
        getUrgentCriterion: (state) => {
            return state.userAlertCriteria.find(c => c.alert_criterion?.name === 'Urgente') || null;
        }
    },

    mutations: {
        setUserAlertCriteria(state, criteria) {
            state.userAlertCriteria = criteria || [];
        },
        updateUserAlertCriterion(state, { criterionId, updatedData }) {
            const index = state.userAlertCriteria.findIndex(c => c.id === criterionId);
            if (index !== -1) {
                state.userAlertCriteria[index] = {
                    ...state.userAlertCriteria[index],
                    days_without_access: updatedData.days_without_access,
                    overall_progress: updatedData.overall_progress
                };
            }
        }
    },

    actions: {
        setUserAlertCriteria({ commit }, criteria) {
            commit("setUserAlertCriteria", criteria);
        },

        async fetchUserAlertCriteria({ commit, dispatch }, payload = {}) {
            try {
                const response = await UserAlertCriterion.getUserAlertCriteria();
                commit("setUserAlertCriteria", response.data || []);
                return response;
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: 'Erro ao buscar critérios de alerta do usuário' }, { root: true });
            }
        },

        async updateUserAlertCriterion({ commit }, payload) {
            try {
                await UserAlertCriterion.updateUserAlertCriterion(payload);
                commit('updateUserAlertCriterion', { criterionId: payload.criterionId, updatedData: payload.criterionData });
            } catch (error) {
                throw new Error("Erro ao atualizar critério de alerta do usuário");
            }
        },

        async updateAllUserAlertCriteria({ state, dispatch }, payload) {
            try {
                const { criteria } = payload;
                const changedCriteria = [];

                criteria.forEach(criterion => {
                    const storeCriterion = state.userAlertCriteria.find(c => c.id === criterion.criterionId);

                    if (storeCriterion) {
                        const shouldUpdate = validateCriteriaShouldBeUpdated(storeCriterion, criterion);
                        if (shouldUpdate) changedCriteria.push(criterion);
                    }
                });

                if (changedCriteria.length === 0) {
                    dispatch('toastfy/activeInfoNotification', { text: 'Nenhuma alteração detectada' });
                    return { updated: false }
                }

                const updates = changedCriteria.map(criterion =>
                    dispatch('updateUserAlertCriterion', criterion)
                );

                await Promise.all(updates);
                dispatch('toastfy/activeSuccesNotification', { text: `Critérios atualizados com sucesso!` }, { root: true });

                return { updated: true };
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: 'Erro ao salvar configurações de alerta' });
            }
        },
    }
}
